import { Link } from 'react-router-dom';
import { animeList } from '@/mocks/anime';

export default function RankSidebar() {
  const hot = [...animeList].sort((a, b) => b.views - a.views).slice(0, 8);

  return (
    <aside className="rounded-lg bg-background-50 border border-background-200 overflow-hidden">
      <div className="flex items-center gap-2 px-5 py-4 border-b border-background-200 bg-primary-50">
        <i className="ri-fire-fill text-accent-500 text-lg"></i>
        <h2 className="text-base font-bold text-foreground-950">热门动漫榜</h2>
        <span className="ml-auto text-xs text-foreground-400">按热度排序</span>
      </div>
      <ul className="divide-y divide-background-200">
        {hot.map((anime, i) => (
          <li key={anime.id}>
            <Link
              to={`/detail/${anime.id}`}
              className="flex items-center gap-3 px-5 py-3 hover:bg-background-100 transition-colors cursor-pointer"
            >
              <span className={`w-6 h-6 flex items-center justify-center rounded-md text-xs font-bold shrink-0 ${i < 3 ? 'bg-accent-500 text-background-50' : 'bg-background-200 text-foreground-600'}`}>
                {i + 1}
              </span>
              <div className="w-10 h-14 rounded-md overflow-hidden bg-background-200 shrink-0">
                <img src={anime.cover} alt={anime.title} title={anime.title} className="w-full h-full object-top" />
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="text-sm font-medium text-foreground-900 line-clamp-1">{anime.title}</h3>
                <p className="mt-0.5 text-xs text-foreground-400 line-clamp-1">{anime.type} · {anime.region}</p>
              </div>
              <span className="text-xs text-foreground-400 shrink-0">
                {(anime.views / 10000).toFixed(1)}万
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </aside>
  );
}